const resources = {
    title: 'Clavardage beauté IA',
    placeholder: 'Message...',
    shareFeedback: 'Partagez vos commentaires',
    new: 'NOUVEAUTÉ',
    addToBasket: 'Ajouter au panier',
    size: 'Format',
    errorMessage: 'Un problème est survenu. Essayez de redémarrer le clavardage ou',
    resendYourMessage: 'renvoyez votre message',
    lookingForAGift: 'Je cherche un cadeau!',
    startChat: 'Démarrez une séance de clavardage',
    tryAsking: 'Essayez de demander',
    topHairCareQuestions: 'Questions les plus fréquentes sur les soins capillaires',
    topSkincareQuestions: 'Questions les plus fréquentes sur les soins de la peau',
    topMakeupQuestions: 'Questions les plus fréquentes sur le maquillage',
    topFragranceQuestions: 'Questions les plus fréquentes sur les parfums',
    topBathBodyQuestions: 'Questions les plus fréquentes sur les essentiels pour le bain et le corps',
    description: 'Soutenu par des millions d’évaluations, des renseignements exclusifs sur les articles et vos préférences personnelles en matière de beauté.',
    feedback: 'Feedback'
};

export default function getResource(label) {
    return resources[label];
}
